// src/utils/sides.ts — kentan paiden nimet
//
// Kentan kaksi paata eivat ole kaikissa halleissa samanarvoisia:
// Vuoksenniskalla toisen takakentan takana on seina lahella, joten
// siella pelaaminen on huonompi arpa. Americano tasaa puolet aina
// (`balanceSides`, src/utils/americano.ts), mutta nimet ovat se mika
// tekee tasauksesta todellisen: ilman niita kukaan ei tieda kumpaan
// paatyyn pitaisi menna, ja tasaus jaa pelkaksi kirjanpidoksi.
//
// Nimet ovat pelipaikan ominaisuus eivatka tapahtuman: seina ei siirry
// illan mukana.

import { Venue } from "../types";

export interface SideNames {
  /** `team1`:n paa. */
  a: string;
  /** `team2`:n paa. */
  b: string;
}

/**
 * Pelipaikan puolten nimet, tai null jos niita ei ole annettu.
 *
 * Null on tarkoituksellinen ero tyhjaan merkkijonoon: klubi, jonka
 * kentat ovat samanarvoisia, ei halua nahda "Puoli 1 / Puoli 2"
 * -riveja missaan. Tasaus tehdaan silti, joten nimien lisaaminen alkaa
 * vaikuttaa heti ilman muuta tyota.
 *
 * Molemmat nimet vaaditaan: toinen yksin ei kerro mihin toinen pari
 * menee.
 *
 * @param venues klubin pelipaikat.
 * @param venueName tapahtuman pelipaikan nimi.
 * @return puolten nimet, tai null.
 */
export function sideNames(venues: Venue[], venueName?: string): SideNames | null {
  if (!venueName) return null;
  const v = venues.find(x => x.name === venueName);
  const a = v?.sideA?.trim();
  const b = v?.sideB?.trim();
  if (!a || !b) return null;
  return {a, b};
}
